import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Types, termsAndPolicyFailure, userType, metaType } from './actions';
import { updateUser } from '../user/actions';
import { toggleLoading } from '../loading/actions';
import userApi from '~/helpers/api/users';

function updateUserState(status: boolean, user: userType) {
  return {
    ...user,
    termoUsoUsuario: {
      ...user?.termoUsoUsuario,
      flagStatusAceite: status,
    },
  };
}

export function* termsAndPolicy({
  status,
  user,
  meta,
}: {
  type: typeof Types.REQUEST;
  status: boolean;
  user: userType;
  meta: metaType;
}) {
  const { onSuccess, onFailure } = meta;

  try {
    yield put(toggleLoading(true));
    yield call(userApi.updateTermsAndPolicy, status);

    const updatedUser = updateUserState(status, user);

    yield put(updateUser(updatedUser));
    onSuccess();
  } catch (error) {
    yield put(termsAndPolicyFailure(error));
    onFailure(error);
  } finally {
    yield put(toggleLoading(false));
  }
}

export default all([takeLatest(Types.REQUEST, termsAndPolicy)]);
